import React from "react";

type Player = "X" | "O";

interface TurnIndicatorProps {
  currentPlayer: Player;
  winner: Player | null;
  isDraw: boolean;
}

export function TurnIndicator({ currentPlayer, winner, isDraw }: TurnIndicatorProps) {
  if (winner) {
    return (
      <div className="result-enter flex items-center gap-2">
        <span
          className="text-lg sm:text-xl font-bold"
          style={{
            fontFamily: "var(--font-mono)",
            color: winner === "X" ? "var(--color-x)" : "var(--color-o)",
            textShadow:
              winner === "X"
                ? "0 0 20px var(--color-x-glow)"
                : "0 0 20px var(--color-o-glow)",
          }}
        >
          {winner}
        </span>
        <span
          className="text-lg sm:text-xl font-semibold"
          style={{ fontFamily: "var(--font-display)", color: "var(--foreground)" }}
        >
          wins!
        </span>
      </div>
    );
  }

  if (isDraw) {
    return (
      <div className="result-enter">
        <span
          className="text-lg sm:text-xl font-semibold"
          style={{
            fontFamily: "var(--font-display)",
            color: "var(--color-dim)",
          }}
        >
          It's a draw
        </span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 transition-all duration-300">
      <span
        className="text-base sm:text-lg"
        style={{
          fontFamily: "var(--font-display)",
          color: "var(--muted-foreground)",
        }}
      >
        Turn:
      </span>
      <span
        className="text-xl sm:text-2xl font-bold transition-colors duration-300"
        style={{
          fontFamily: "var(--font-mono)",
          color: currentPlayer === "X" ? "var(--color-x)" : "var(--color-o)",
          textShadow:
            currentPlayer === "X"
              ? "0 0 12px var(--color-x-glow)"
              : "0 0 12px var(--color-o-glow)",
        }}
      >
        {currentPlayer}
      </span>
    </div>
  );
}
